import feesAndChargesContent from './content/fees-and-charges.json';

const feesAndChargesMock = {
    layoutType: 2,
    data: {
        name: 'fees-and-charges',
        layoutType: 2,
        areasList: [
            {
                id: 'fees-and-charges-page-area',
                name: 'Content',
                componentName: 'Comp:FeesChargesPage',
                content: JSON.stringify(feesAndChargesContent),
            },
        ],
    },
};

export default feesAndChargesMock;
